module.exports = __webpack_public_path__ + "static/desktop-easy-login-36a293f45a6f53bb143d3ae73256dacf.png";